import { Link, useNavigate } from '@tanstack/react-router'
import { Button, Tag } from 'antd'
import React, { FC } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const StyledLinkButton = styled(Button)`
  color: ${CantileverTheme.colors.slate[300]} !important;
  display: flex;
  flex-wrap: wrap;
  white-space: normal;
  height: auto;
`

type StringRendererProps = {
  value: string
  linkProps?: LinkProps
}

export const StringRenderer: FC<StringRendererProps> = ({
  value,
  linkProps,
}) => {
  const navigate = useNavigate()

  if (!value) {
    return <></>
  }

  const handleClick = () => {
    if (linkProps) {
      navigate({
        to: linkProps.to,
        params: linkProps.params,
        search: linkProps.search,
      })
    }
  }

  return linkProps ? (
    <StyledLinkButton type='link' onClick={handleClick}>
      {value}
    </StyledLinkButton>
  ) : (
    <span>{value}</span>
  )
}

type TagRendererProps = {
  value?: string
  color?: string
  linkProps?: LinkProps
}

export const TagRenderer: FC<TagRendererProps> = ({
  value,
  color = 'green',
  linkProps,
}) => {
  if (!value) {
    return <></>
  }

  return (
    <Tag color={color}>
      {linkProps ? <Link {...linkProps}>{value}</Link> : value}
    </Tag>
  )
}

export type LinkProps = {
  to: string
  params: Record<string, string>
  target?: string
  search?: Record<string, string>
}

export const defaultStringValueRenderer = (value: string) => (
  <StringRenderer value={value} />
)
